import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { EqmInspectResultDetailDto, EqmInspectResultHeaderDto } from "src/dtos/eqmInspectResult/eqmInspectResultDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { EQM2070_R01Dto, EQM2070_R01InspectMasterDto } from "./Dto_EQM2070_R01";
import { EQM2070_R01Filter } from "./Store_EQM2070_R01";

const baseUrl = `${config.apiUrl}/EQM2070_R01`;

const getParams = (filter: Partial<EQM2070_R01Filter>, listLength?: number) => ({
	compCd: filter.compCd || "",
	inspectDt: filter.inspectDt || "",
	equipmentCd: filter.equipmentCd || "",
	listLength: listLength || 0,
});

export const getEQM2070_R01List = async (
	option: string,
	params: Partial<EQM2070_R01Filter>,
	listLength: number = 0,
) => {
	const url = `${baseUrl}/${option}`;
	return await getData<ResponseDto<EqmInspectResultHeaderDto[]>>(url, {
		params: getParams(params, listLength),
	});
};

export const getEQM2070_R01AllCount = async (params: Partial<EQM2070_R01Filter>) => {
	const url = `${baseUrl}/allCount`;
	return await getData<ResponseDto<number>>(url, {
		params: getParams(params, 0),
	});
};

export const getEQM2070_R01DetailList = async (inspectNo: string) => {
	const url = `${baseUrl}/detail/${inspectNo}`;
	return await getData<ResponseDto<EqmInspectResultDetailDto[]>>(url);
};

export const getEQM2070_R01InspectList = async (params: Partial<EQM2070_R01Filter>) => {
	const url = `${baseUrl}/inspect`;
	return await getData<ResponseDto<EQM2070_R01InspectMasterDto[]>>(url, {
		params: getParams(params, 0),
	});
};

export const postEQM2070_R01 = async (data: EQM2070_R01Dto) => {
	const url = `${baseUrl}`;
	return await postData<EQM2070_R01Dto, ResponseDto<EQM2070_R01Dto[]>>(url, data);
};

export const patchEQM2070_R01 = async (data: EQM2070_R01Dto) => {
	const url = `${baseUrl}`;
	return await patchData<EQM2070_R01Dto, ResponseDto<EQM2070_R01Dto[]>>(url, data);
};

export const deleteEQM2070_R01 = async (inspectNo: string, itemNo?: string) => {
	const url = `${baseUrl}`;
	return await deleteData<ResponseDto<any>>(url, {
		params: {
			inspectNo,
			itemNo,
		},
	});
};

export const downloadExcel_EQM2070_R01 = async (
	option: string,
	inspectNo: string,
	listLength: number = 0,
) => {
	const url = `${baseUrl}/excel/${option}`;
	return await getData<ResponseDto<string>>(url, {
		params: {
			inspectNo,
			listLength,
		},
	});
};

export const getPdfBlob_EQM2070_R01 = async (inspectNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { inspectNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};
